export default __webpack_public_path__ + "static/media/DMCardImage.e6b070ff.png";